import {
  createShallowEqualSelector,
  makeMarginStyleSelector,
  makePaddingStyleSelector,
  makeSizeStyleSelector
} from "@client/selectors";
import { type AppState } from "@client/types";
import * as React from "react";
import { type ExlcudeSettings } from "./container";

export const propsExlcudeSettingsSelector = (state: AppState, props: { exlcudeSettings?: ExlcudeSettings[] }) =>
  props.exlcudeSettings;
export const propsStyleSelector = (state: AppState, props: { style?: React.CSSProperties }) => props.style;

export const makeStyleSelector = (target: string) => {
  const marginStyleSelector = makeMarginStyleSelector(target);
  const paddingStyleSelector = makePaddingStyleSelector(target);

  const sizeStyleSelector = makeSizeStyleSelector(target);

  return createShallowEqualSelector(
    [sizeStyleSelector, propsStyleSelector, marginStyleSelector, paddingStyleSelector, propsExlcudeSettingsSelector],
    (sizeStyle, propsStyle, marginStyle, paddingStyle, exlcudeSettings): React.CSSProperties => {
      return {
        ...sizeStyle,
        ...(exlcudeSettings?.includes("margin") ? {} : marginStyle),
        ...(exlcudeSettings?.includes("padding") ? {} : paddingStyle),
        ...propsStyle
      };
    }
  );
};
